export const sendBecomeProviderRequest = async (formData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/Provider/become-provider`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      return errorData;
    }
    return { success: true, message: "" };
  } catch (error) {
    console.error("Erreur lors de l'envoi de la demande :", error);
    return {
      success: false,
      message: "Une erreur s'est produite. Veuillez réessayer.",
    };
  }
};
